import { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

export const ChangePasswordForm = ({ onDone }) => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setF({ current_password: "", new_password: "", confirm: "" });
      onDone?.();
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
      {[["current_password", "Current / temporary password"], ["new_password", "New password (min 8 chars)"], ["confirm", "Confirm new password"]].map(([k, l]) => (
        <div key={k} className="space-y-1.5">
          <Label>{l}</Label>
          <Input type="password" required value={f[k]} onChange={set(k)} data-testid={`cp-${k}-input`} className="bg-white" />
        </div>
      ))}
      <Button type="submit" disabled={busy} data-testid="cp-submit-button" className="bg-[#E08A1E] hover:bg-[#C87515] text-white rounded-full">
        {busy ? "Saving..." : "Update password"}
      </Button>
    </form>
  );
};
